class RecipientForm extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.fieldsWrap = this.querySelector('.recipient-fields');
    this.liveRegion = this.querySelector('[id^="Recipient-fields-live-region"]');
    this.timezoneInput = this.querySelector('input[name="properties[__shopify_offset]"]');
    this.variantId = this.dataset.productVariantId;

    // Enable checkbox and inputs
    if (this.checkbox) {
      this.checkbox.removeAttribute('disabled');
      this.checkbox.addEventListener('change', this.onToggle.bind(this));
    }

    // Set timezone offset
    if (this.timezoneInput) {
      try {
        const offsetMin = new Date().getTimezoneOffset();
        this.timezoneInput.value = String(offsetMin);
        this.timezoneInput.removeAttribute('disabled');
      } catch (e) {}
    }

    // Basic live region updates (a11y)
    this.fieldsWrap?.addEventListener('input', () => {
      if (!this.liveRegion) return;
      const email = this.querySelector('#Recipient-email-' + this.dataset.sectionId)?.value || '';
      this.liveRegion.textContent = email ? 'Recipient email entered' : '';
    });
  }

  onToggle() {
    const enabled = this.checkbox.checked;
    const inputs = this.fieldsWrap?.querySelectorAll('input, textarea') || [];
    inputs.forEach((el) => {
      el.disabled = !enabled;
    });

    if (this.liveRegion) {
      this.liveRegion.textContent = enabled ? 'Recipient form enabled' : 'Recipient form disabled';
    }
  }
}

customElements.define('recipient-form', RecipientForm);
